import MS_CONST from './msconst.js'

//-----------------------------------------------------------------------
//-----------------------------------------------------------------------
class msCache {
    constructor(id) {
        this.id = id;
    }
    //-----------------------------------------------------------------------
    loadCache(callback) {
        caches.open(MS_CONST.CACHE_PREFIX).then((cache) => {
            var cacheid = '/' + this.id + '.json';
            cache.match(cacheid).then(function (response) {
                if (typeof response == 'undefined') {
                    // not found
                    callback(false);
                }
                else
                    response.json().then((buffer) => {
                        callback(buffer);
                    });
            });
        });
    }
    //-----------------------------------------------------------------------
    saveCache(responseData, callback) {
        caches.open(MS_CONST.CACHE_PREFIX).then((cache) => {            
            var cacheid = '/' + this.id + '.json';
            cache.put(cacheid, new Response(JSON.stringify(responseData)));
            if (callback) 
                callback();
        });    
    }
    //-----------------------------------------------------------------------
    deleteCache(callback) {
        caches.open(MS_CONST.CACHE_PREFIX)
        .then((cache) => {            
            var cacheid = '/' + this.id + '.json';
            cache.delete(cacheid);
            if (callback)
                callback();
        })
        .catch(function(error) {
            if (callback)
                callback();
        });
    }
    //-----------------------------------------------------------------------
}

export default {
    msCacheAdvertise: new msCache(MS_CONST.CACHE_ADVERTISE),
    msCacheContent: new msCache(MS_CONST.CACHE_CONTENT),
    msCacheSettings: new msCache(MS_CONST.CACHE_SETTINGS),
    msCacheLogin: new msCache(MS_CONST.CACHE_LOGIN),
    msCacheWebbook: new msCache(MS_CONST.CACHE_WEBBOOK),
}